import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { fontSize } from '../../mixins'


const StyledOptionRow = styled.div`
  display: flex;
  align-items: center;
  
  &:not(:last-child) {
    margin-bottom: 32px;
    
    @media screen and (max-width: 430px) {
      margin-bottom: ${({isPromo}) => isPromo ? '16px' : '24px'};
    }
  }
`;

const StyledImg = styled.img`
  margin-right: ${({isPromo}) => isPromo ? '18px' : '24px'};
  width: ${({isPromo}) => isPromo ? '53px' : '40px'};
  height: ${({isPromo}) => isPromo ? '53px' : '40px'};
`;

const StyledTitle = styled.div`
  font-weight: 700;
  ${fontSize(16)};
  line-height: 19px;
  color: #ffffff;
  margin-bottom: 2px;
`;

const StyledSubTitle = styled.span`
  font-weight: 400;
  ${fontSize(14)};
  line-height: 16px;
  color: #ffffff;
`;


const LatamOptions = ({isPromo}) => {
  const {t} = useTranslation();
  const Options = [
    {
      id: 0,
      src: '../assets/plan_options/CheckLocationFamilyCircle.svg',
      title: `${t('real_time_location')}`,
      subtitle: `${t('real_time_location_sub')}`,
    },
    {
      id: 1,
      src: '../assets/plan_options/PlaceAlertsCircle.svg',
      title: `${t('place_alerts')}`,
      subtitle: `${t('place_alerts_sub')}`,
    },
    {
      id: 2,
      src: '../assets/plan_options/FindLovedCircle.svg',
      title: `${t('find_loved')}`,
      subtitle: `${t('find_loved_sub')}`,
    },
    {
      id: 3,
      src: '../assets/plan_options/ShareFlightStatusCircle.svg',
      title: `${t('share_flight')}`,
      subtitle: `${t('share_flight_sub')}`,
    },
    {
      id: 4,
      src: '../assets/plan_options/AutoSosCircle.svg',
      title: `${t('auto_sos')}`,
      subtitle: `${t('auto_sos_sub')}`,
    },
  ];

  const renderOptions = i => (
    <React.Fragment key={i.id}>
      <StyledOptionRow isPromo={isPromo}>
        <StyledImg src={i.src} alt={i.title} isPromo={isPromo} />
        <div>
          <StyledTitle>{i.title}</StyledTitle>
          <StyledSubTitle>{i.subtitle}</StyledSubTitle>
        </div>
      </StyledOptionRow>
    </React.Fragment>
  );


  return Options.map(renderOptions)
};

export default LatamOptions
